import { render, staticRenderFns } from "./FieldsPage.vue?vue&type=template&id=55f8256f&scoped=true"
import script from "./FieldsPage.vue?vue&type=script&lang=js"
export * from "./FieldsPage.vue?vue&type=script&lang=js"
import style0 from "./FieldsPage.vue?vue&type=style&index=0&id=55f8256f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f8256f",
  null
  
)

export default component.exports